import { h, JSX } from '@stencil/core';
import { CmsLink } from '../../types/global';
import { createAbsoutePathIfRelative, DEFAULT_TRACKING_DELAY, delayPageChange } from './tracking-helpers';

export function renderLink(
  link: CmsLink,
  inverted: boolean,
  style?: 'link' | 'button' | 'anchor' | 'tags',
  onLinkClick?: (event: Event, link: CmsLink, linkElement?: HTMLElement) => void
): JSX.Element {
  // Default click handler if none provided
  const handleLinkClick =
    onLinkClick ||
    ((event: Event, link: CmsLink, linkElement?: HTMLElement) => {
      delayPageChange(
        DEFAULT_TRACKING_DELAY,
        event,
        (linkElement as HTMLAnchorElement) || (event.currentTarget as HTMLAnchorElement)
      );

      const trackingEvent = {
        eventInfo: {
          eventName: 'Click Link in List',
          eventType: 'Action',
          eventCaller: event.currentTarget,
        },
        attributes: {
          elementType: 'Link',
          elementLabel: link.title,
          target: createAbsoutePathIfRelative(link.src),
        },
        category: {
          area: 'Content',
        },
      };

      window.ui?.services?.tracking?.track(trackingEvent);
    });

  switch (style) {
    case 'anchor':
      return renderAnchorLink(link, inverted, handleLinkClick);
    case 'tags':
      return renderTagLink(link, inverted, handleLinkClick);
    default:
      return <ui-cms-link body={link} inverted={inverted}></ui-cms-link>;
  }
}

function renderAnchorLink(
  link: CmsLink,
  inverted: boolean,
  onLinkClick: (event: Event, link: CmsLink) => void
): JSX.Element {
  return (
    <sd-link
      href={link.src}
      target={link.target}
      inverted={inverted}
      onClick={(event: Event) => {
        onLinkClick(event, link);
      }}
    >
      <sd-icon
        library={window.ui.cmsState.iconLibrary}
        slot="icon-left"
        name="union-investment/system/anchor-link"
      ></sd-icon>
      <b>{link.title}</b>
    </sd-link>
  );
}

function renderTagLink(
  link: CmsLink,
  inverted: boolean,
  onLinkClick: (event: Event, link: CmsLink) => void
): JSX.Element {
  return (
    <sd-tag
      href={link.src}
      target={link.target}
      inverted={inverted}
      onClick={(event: Event) => {
        onLinkClick(event, link);
      }}
    >
      {link.title}
    </sd-tag>
  );
}
